import { Alert, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import useTranslations from '../../../../i18n/useTranslations'

import PickupView from './View'
import styles from './styles'

export const PICKUP_OPTIONS = {
  asap: 'asap',
  chooseDayAndHour: 'chooseDayAndHour',
  requestLater: 'requestLater',
  fixedPickUp: 'fixedPickUp',
}

export const SCHEDULE_OPTIONS = {
  anytime: 'anytime',
  chooseTimezone: 'chooseTimezone',
}

const propTypes = {
  children: PropTypes.node,
  pickupSource: PropTypes.string,
  pickup: PropTypes.string,
  isChoosePickupDateDisabled: PropTypes.bool,
  postalCode: PropTypes.string,
  changePickupSource: PropTypes.func,
  fixedPickupTimeZone: PropTypes.shape({
    fromDate: PropTypes.date,
    toDate: PropTypes.date,
  }),
}

const Pickup = ({
  changePickupSource,
  pickupSource,
  pickup,
  isChoosePickupDateDisabled,
  postalCode,
  fixedPickupTimeZone,
  children,
}) => {
  const formatMessage = useTranslations()

  return (
    <PickupView
      isChoosePickupDateDisabled={isChoosePickupDateDisabled}
      pickupSource={pickupSource}
      changePickupSource={changePickupSource}
      fixedPickupTimeZone={fixedPickupTimeZone}
    >
      {/* TODO: considerar utilizar únicamente `undefined` o `null` para
          comprobar si el código postal está informado. */}
      {postalCode === undefined || postalCode === null || postalCode === '' ? (
        <Alert severity="info" sx={styles.alert}>
          <Typography variant="h3medium">
            {formatMessage(
              pickupSource === PICKUP_OPTIONS.asap ||
                pickupSource === PICKUP_OPTIONS.fixedPickUp
                ? 'shipping-send-form:origin:pickup:asap-requirements'
                : 'shipping-send-form:origin:pickup:choose-requirements',
            )}
          </Typography>
        </Alert>
      ) : (
        <>
          {children}
          {pickup !== null ? (
            <Alert severity="warning" sx={styles.alert}>
              <Typography variant="body2">
                {formatMessage('shipping-send-message:schedule-may-change')}
              </Typography>
            </Alert>
          ) : null}
        </>
      )}

      {pickupSource === PICKUP_OPTIONS.requestLater && (
        <>
          <Typography style={styles.alertText} variant="body2">
            {formatMessage('shipping-send-message:request-pickup-later')}
          </Typography>
          <Typography style={styles.alertText} variant="body2">
            <strong>
              {formatMessage('shipping-send-message:request-pickup-later-2')}
            </strong>
          </Typography>
        </>
      )}
    </PickupView>
  )
}

Pickup.propTypes = propTypes

export default Pickup
